import { useFilters } from '@statsbomb/kitbag-global-football';
import {
  playerComparisonGamesBySeasonAtom,
  playerComparisonSelectedGamesAtom,
} from '@/atoms/filters/player/playerComparisonGames';
import { playerGamesBySeasonAtom, playerSelectedGamesAtom } from '@/atoms/filters/player/playerGames';
import { useGameSummary } from '@/hooks/useGameSummary';

export const usePlayerGameSummary = () => {
  const [{ gameType, periodRange, startDate, endDate }] = useFilters('main');
  return useGameSummary({
    selectedGamesAtom: playerSelectedGamesAtom,
    gamesGroupedBySeasonAtom: playerGamesBySeasonAtom,
    gameType,
    periodRange,
    startDate,
    endDate,
  });
};

export const useComparisonPlayerGameSummary = () => {
  const [{ gameType, periodRange, startDate, endDate }] = useFilters('comparison');
  return useGameSummary({
    selectedGamesAtom: playerComparisonSelectedGamesAtom,
    gamesGroupedBySeasonAtom: playerComparisonGamesBySeasonAtom,
    gameType,
    periodRange,
    startDate,
    endDate,
  });
};
